module.exports = __webpack_public_path__ + "static/media/congratulation_bg.9a1d9bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/congratulation_bg.svg
// module id = 60
// module chunks = 0